import React, { useState } from "react";
import { getPageStyles } from "../../SiteManagement/styles"; //TODO export these further up!
import {
  Button,
  Container,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DeleteModal from "../Common/DeleteModal";
import { SSOProviderDTO } from "@beable/roster-backend-client-v1";
import { SUBPAGES } from "../constants";
import AddProviderModal from "./AddProviderModal";
import EditProviderModal from "./EditProviderModal";

interface SSOProviderActionsProps {
  selectedItem?: SSOProviderDTO;
  onActionComplete: (success: boolean) => void;
}

export default function SSOProviderActions({
  selectedItem,
  onActionComplete,
}: SSOProviderActionsProps) {
  const theme = useTheme();
  const styles = getPageStyles(theme);

  const [displayModal, setDisplayModal] = useState<
    "add" | "edit" | "delete" | undefined
  >();

  const closeModal = (success: boolean) => {
    setDisplayModal(undefined);
    onActionComplete(success);
  };

  const formatText = (item: SSOProviderDTO) => {
    let label = item.name;
    if (item.environment) label += ` (${item.environment})`;
    return label?.length ? label : "unknown";
  };

  return <>
    <Container sx={styles.dfb}>
      <Button
        sx={styles.verticalBtn}
        variant="contained"
        color="primary"
        onClick={() => setDisplayModal("add")}
      >
        Add new provider
      </Button>
    </Container>
    {selectedItem?.id ? (
      <>
        <Typography variant="h5" sx={{ margin: "16px" }}>
          Options for {formatText(selectedItem)}
        </Typography>
        <Container sx={styles.dfb}>
          <Button
            sx={styles.verticalBtn}
            variant="contained"
            color="secondary"
            onClick={() => setDisplayModal("edit")}
          >
            Edit
          </Button>
          <Button
            sx={[styles.verticalBtn, styles.plainBtn]}
            variant="contained"
            onClick={() => setDisplayModal("delete")}>
            Delete
          </Button>
        </Container>
      </>
    ) : undefined}
    <AddProviderModal
      open={displayModal === "add"}
      handleClose={closeModal}
    />
    {selectedItem ? (
      <>
        <EditProviderModal
          open={displayModal === "edit"}
          handleClose={closeModal}
          providerItem={selectedItem}
        />
        <DeleteModal
          open={displayModal === "delete"}
          handleClose={closeModal}
          subpage={SUBPAGES.providers.value}
          item={selectedItem}
          name={selectedItem.name}
        />
      </>
    ) : undefined}
  </>;
}